import React from "react";
import axios from "axios";
import { SearchIcon, SignOutIcon, defaultLogo } from "../../Assets/Icons";
import UnoAppsPopover from "../Popover/UnoAppsPopover";
import ThemeSwitchButton from "../Buttons/ThemeSwitchButton";
import { useUnoSelector } from "../../Provider/Provider";
import jwtEncode from "jwt-encode";
import { RiMenu2Fill } from "react-icons/ri";

const Header = ({
  searchProps,
  appLogo = null,
  showSearch = true,
  showDrawer = true,
  showThemeSwitch = false,
  userDetails = {},
  appName = "",
  hideSidebar,
  showHamburger = false,
  logoutHandler,
}) => {
  const { user, token } = useUnoSelector((state) => state?.user);
  const applicationData = useUnoSelector((state) => state?.application);
  const configData = useUnoSelector((state) => state?.config);
  const { email, name, designation, image } = userDetails;
  const placeholderUserName = (user?.name || name)
    ?.split(" ")
    .slice(0, 2)
    .map((e) => e.charAt(0).toUpperCase())
    .join("");

  const appDrawerData = applicationData?.apps?.filter((item) => item.uuid !== applicationData?.currentApplicationId);

  const logOut = async () => {
    localStorage.clear();
    sessionStorage.clear();
    if (configData?.config?.UNO_URL) {
      await axios.post(
        `${configData?.config?.UNO_URL}/api/auth/logout`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      window.location.href = `${configData?.config?.redirectUri}`;
    } else if (logoutHandler) {
      logoutHandler();
    }
  };

  const redirectApplication = (e) => {
    const link = e.channel?.origins[0]?.url;
    if (token && link) {
      const payload = { token: token };
      const jwtToken = jwtEncode(payload, "");

      if (link.includes("apps.simulanis.io")) {
        const newUrl = `${link}`;
        window.location.href = newUrl;
      } else {
        const newUrl = `${link}?referrer=${jwtToken}`;
        window.location.href = newUrl;
      }
    }
  };

  const OnToggleSidebar = () => {
    hideSidebar();
  };

  return (
    <header className="main-head">
      <div className="left">
        <span className="logo">
          <img src={configData?.config?.logo || appLogo || defaultLogo} referrerPolicy={"no-referrer"} />
          <p>{configData?.config?.name || appName || ""}</p>
        </span>
        {showHamburger && (
          <button className="hamburgertoggle" onClick={OnToggleSidebar}>
            <RiMenu2Fill />
          </button>
        )}
      </div>

      <div className="right ">
        {showSearch && (
          <div className="main-search">
            <span className="search-icon">
              <SearchIcon />
            </span>
            <input type="text" className="form-control" autoComplete="off" {...searchProps} />
          </div>
        )}
        <div className="dropdown">
          <div className="profile-info dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
            <span className="name-email">
              <h6>{user?.name || name}</h6>
              <p>{user?.designation || designation}</p>
            </span>
            {user?.avatar || image ? (
              <img src={user?.avatar || image} referrerPolicy={"no-referrer"} />
            ) : (
              <span className="placeholder"> {placeholderUserName} </span>
            )}
          </div>
          <div className="dropdown-menu profile-detail-parent p-0">
            <div className="profile-detail">
              <div className="bg">
                {user?.avatar || image ? (
                  <img src={user?.avatar || image} referrerPolicy={"no-referrer"} />
                ) : (
                  <span> {placeholderUserName} </span>
                )}
              </div>
              <span className="name-email">
                <p>{user?.name || name}</p>
                <p>{user?.email || email}</p>
                
              </span>
              <span className="signout" onClick={logOut}>
                <SignOutIcon />
                Sign Out
              </span>
            </div>
          </div>
        </div>

        {showThemeSwitch && <ThemeSwitchButton />}

        {showDrawer && <UnoAppsPopover applications={appDrawerData} onAppClick={redirectApplication} />}
      </div>
    </header>
  );
};

export default Header;
